import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Czech (the only language for now — add more locales next to `cs/`)
import csCommon from "./locales/cs/common.json";
import csNav from "./locales/cs/nav.json";
import csAuth from "./locales/cs/auth.json";
import csErrors from "./locales/cs/errors.json";

export const NAMESPACES = ["common", "nav", "auth", "errors"] as const;

export const LOCALE_MAP: Record<string, string> = {
  cs: "cs-CZ",
};

void i18n.use(initReactI18next).init({
  resources: {
    cs: { common: csCommon, nav: csNav, auth: csAuth, errors: csErrors },
  },
  lng: "cs",
  fallbackLng: "cs",
  defaultNS: "common",
  ns: NAMESPACES as unknown as string[],
  interpolation: { escapeValue: false },
});

export default i18n;
